import { api } from '@/shared/api/client';
import type { ResendVerificationRequest } from '../model/dto';

export const postAuthResendVerification = async (
  payload: ResendVerificationRequest
) => {
  const { data } = await api.post('/auth/resend-verification/', payload);
  return data;
};
